import { render, staticRenderFns } from "./TabletLogs.vue?vue&type=template&id=66236aa9&"
import script from "./TabletLogs.vue?vue&type=script&lang=js&"
export * from "./TabletLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports